import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../useTranslation';
import { getApiLang, getAppLanguage } from '../../utils/language';

const API_BASE = '/api/v1';

/** Страница перехода по ссылке из письма подтверждения почты (/confirm-email?token=...). */
export const ConfirmEmailPage: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const language = getAppLanguage();
  const { t } = useTranslation(language);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const lang = getApiLang(language);
    if (!token) {
      setStatus('error');
      setMessage(t.missingResetToken);
      return;
    }
    fetch(`${API_BASE}/auth/confirm-email?token=${encodeURIComponent(token)}&lang=${lang}`, { credentials: 'include' })
      .then(async (r) => {
        if (r.ok) {
          setStatus('ok');
          setMessage(t.confirmEmailTitle);
        } else {
          setStatus('error');
          const body = await r.json().catch(() => ({}));
          setMessage(typeof body.detail === 'string' ? body.detail : t.requestFailed);
        }
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || t.requestFailed);
      });
  }, [language]);

  return (
    <div className="min-h-dvh flex items-center justify-center p-4">
      <div className="glass-panel p-6 sm:p-8 max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <div className="animate-spin rounded-full h-10 w-10 border-2 border-stone-300 border-t-blue-600 mx-auto" />
            <p className="mt-4 text-stone-600 dark:text-slate-400">{t.confirmingEmail}</p>
          </>
        )}
        {status === 'ok' && (
          <>
            <p className="text-stone-800 dark:text-white font-medium">{message}</p>
            <p className="text-sm text-stone-500 dark:text-slate-400 mt-2">{t.confirmEmailSuccessSubtitle}</p>
            <a href="/" className="mt-6 inline-block text-blue-600 dark:text-blue-400 hover:underline">{t.goToApp}</a>
          </>
        )}
        {status === 'error' && (
          <>
            <p className="text-red-600 dark:text-red-400 font-medium">{t.confirmEmailError}</p>
            <p className="text-sm text-stone-500 dark:text-slate-400 mt-2">{message}</p>
            <a href="/" className="mt-6 inline-block text-blue-600 dark:text-blue-400 hover:underline">{t.backToApp}</a>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmEmailPage;
